import { getState } from "../../state/store";
import { httpClient, loadLocalizationConfig, setLocale } from "../../services";

const versionFileUrl = "/version.txt";

const initApplication = async () => {
  const lang = getState().localization.langCode;

  await loadLocalizationConfig();
  await setLocale(lang);
};

const getAppVersion = async () => {
  const { data } = await httpClient.get(versionFileUrl);
  return data;
};

const applicationService = {
  initApplication,
  getAppVersion
};

export default applicationService;
